import React from "react";
import { CheckCircleIcon } from "lucide-react";
import { CHECKOUT_URL } from "./data";
type Props = {
  label?: string;
  className?: string;
  onClickTrack?: boolean;
};
export function CTAButton({
  label = "QUIERO EL PROTOCOLO CLÍNICA SEGURA",
  className = ""
}: Props) {
  const handleClick = () => {
    if (typeof window !== "undefined" && (window as any).fbq) {
      (window as any).fbq("track", "InitiateCheckout");
    }
  };
  return <a href={CHECKOUT_URL} onClick={handleClick} className={`group relative flex w-full items-center justify-center gap-2 rounded-2xl bg-[var(--cta)] px-5 py-4 text-center text-base font-extrabold uppercase tracking-wide text-white shadow-[0_10px_30px_-8px_rgba(34,165,89,0.7)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-[var(--cta-dark)] active:translate-y-0 sm:text-lg md:px-8 md:py-5 md:text-xl ${className}`} style={{
    animation: "pulse-cta 2.4s ease-in-out infinite"
  }} data-id="element-78" data-mp="2tx9u6jbqpe1e">
      <CheckCircleIcon className="h-5 w-5 shrink-0 md:h-6 md:w-6" strokeWidth={2.5} data-id="element-79" data-mp="198wk989rxg42" />
      <span className="leading-tight" data-id="element-80" data-mp="19b98g364kmpk">{label}</span>
      <style data-id="element-81" data-mp="1dbjdndm3f93d">{`
        @keyframes pulse-cta {
          0%, 100% { box-shadow: 0 10px 30px -8px rgba(34,165,89,0.6); }
          50% { box-shadow: 0 12px 40px -6px rgba(34,165,89,0.95); }
        }
      `}</style>
    </a>;
}